import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserGroupsState } from '../../../../../store/samwin/user-groups/user-groups.state';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AvailableUserGroupRemoteDto } from 'src/generated/signalR/available-user-group-remote-dto';

@Component({
   selector: 'samweb-group-names-for-ids',
   templateUrl: './group-names-for-ids.component.html',
   styleUrls: ['./group-names-for-ids.component.scss'],
})
export class GroupNamesForIdsComponent implements OnInit {
   @Input()
   groupId: number;

   @Input()
   isLast: boolean;

   groupInfo$: Observable<AvailableUserGroupRemoteDto>;

   constructor(private store: Store) {
      this.groupInfo$ = this.store.select(UserGroupsState.getGroupForId).pipe(map((x) => x(this.groupId)));
   }

   ngOnInit(): void {}
}
